'use client'

import { useEffect } from 'react'

/**
 * Registers the service worker for PWA / offline support.
 * Must be rendered inside a Client Component tree.
 * Safe to render in the root layout — no-ops in SSR.
 */
export function ServiceWorkerRegistration() {
  useEffect(() => {
    if (typeof window === 'undefined') return
    if (!('serviceWorker' in navigator)) return

    navigator.serviceWorker
      .register('/sw.js', { scope: '/' })
      .catch(() => {
        // SW registration failure is non-fatal — the app works without it.
      })
  }, [])

  return null
}
